import { Redirect, Route } from 'wouter'

import { FaucetPage } from '../FaucetPage'

const RootRedirect = () => <Redirect to="/kovan" />

export const App = () => {
  return (
    <>
      <Route path="/" component={RootRedirect} />
      <Route path="/:network">
        {({ network }) => {
          if (network !== 'kovan') {
            return null
          }

          return <FaucetPage network={network} />
        }}
      </Route>
    </>
  )
}
